import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";

const INCLUDES = [
  "2 small-group personal training sessions weekly",
  "Unlimited Kore Classes — Kombat, Blast, Zones, Ascent",
  "Your own training app + programmed workouts",
  "Nutrition guide & personal support",
  "Monthly 1-to-1 coach check-ins",
  "Priority class booking + community",
];

// Reusable banner used across pages. Two variants:
//   variant="hero"  – full-bleed dark forest section (use as a homepage anchor)
//   variant="inline"– lighter card style that slots between page sections
export default function TrialCTA({ variant = "inline", eyebrow = "Start with the 30 Day Coached Trial" }) {
  const isHero = variant === "hero";
  return (
    <section
      data-testid={`trial-cta-${variant}`}
      className={
        isHero
          ? "bg-kore-forest text-kore-warm py-24 md:py-32"
          : "py-16 md:py-20"
      }
    >
      <div className={isHero ? "container-kore" : "container-kore"}>
        <div
          className={
            isHero
              ? "grid md:grid-cols-12 gap-12 items-center"
              : "rounded-3xl bg-kore-forest text-kore-warm p-8 md:p-14 grid md:grid-cols-12 gap-10 items-center"
          }
        >
          <div className="md:col-span-6">
            <span className="text-[11px] uppercase tracking-[0.28em] text-kore-light">{eyebrow}</span>
            <h2 className={`font-display font-light leading-[1.05] mt-4 ${isHero ? "text-5xl md:text-6xl" : "text-4xl md:text-5xl"}`}>
              30 days of KORE Coaching
              <br />
              <span className="text-kore-light">for £99.</span>
            </h2>
            <p className="mt-6 text-kore-warm/80 leading-relaxed max-w-lg">
              Everything Kore has to offer — coached training, unlimited classes, nutrition, community and check-ins — for one flat price. No open-ended contract. No pressure.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/30-day-trial" data-testid="trial-cta-primary" className="btn-gold">
                Come and see how KORE works <ArrowUpRight size={14} />
              </Link>
              <Link to="/memberships" data-testid="trial-cta-secondary" className="btn-ghost !text-kore-warm !border-kore-warm/30">
                See memberships
              </Link>
            </div>
          </div>
          <div className="md:col-span-6 md:pl-8 md:border-l md:border-kore-warm/15">
            <div className="text-[11px] uppercase tracking-[0.24em] text-kore-light">What&rsquo;s included</div>
            <ul className="mt-5 space-y-3">
              {INCLUDES.map((line) => (
                <li key={line} className="flex gap-3 text-kore-warm/90 leading-relaxed text-sm md:text-[15px]">
                  <span className="mt-0.5 rounded-full bg-kore-light/15 border border-kore-light/40 p-1"><Check size={12} className="text-kore-light" /></span>
                  <span>{line}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex items-baseline gap-2 text-kore-warm/60 text-xs uppercase tracking-[0.2em]">
              <span>Then</span>
              <span className="text-kore-warm">£149/month</span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
